module.exports = __webpack_public_path__ + "media/images/lilica/lilica4-0d42852213bf8d70d05c198f5189ce86.png";